function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { purifier } from "../../util/dom";
import { deepMerge } from "../../util/object";
import { cleanNonLatinExtended, inputError, replaceAllShortcode } from "../../util/string";
import store from "../store";
import { isBundle } from "../../components/bundles";
var getProductData = function getProductData(productId) {
  var _store$getState = store.getState(),
    productCache = _store$getState.productCache;
  if (productCache.hasOwnProperty('items') && productCache.items.hasOwnProperty(productId)) {
    return productCache.items[productId];
  }
  return {};
};
var extractProductId = function extractProductId(item) {
  return _typeof(item) === 'object' && item.hasOwnProperty('item') ? item.item.slice(0, item.item.indexOf("-")) : '';
};
var localizeProductData = function localizeProductData() {
  var productData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (productData.localized && productData.localized[window.sitewide.language]) {
    return deepMerge(productData, productData.localized[window.sitewide.language]);
  }
  return productData;
};
var updateFieldState = function updateFieldState(el, isError, errorClass, isValid) {
  var validClass = 'is-valid';
  if (typeof isError !== 'undefined' && isError == true) {
    el.addClass(errorClass).removeClass(validClass);
  } else if (isValid == true) {
    el.removeClass(errorClass).addClass(validClass);
  } else {
    el.removeClass(errorClass).removeClass(validClass);
  }
};
var checkError = function checkError(field, value) {
  var country = store.getState().store.country;
  var tempValue = value;
  var tempField = field === "email" ? "email" : "text";
  if (field === 'phoneNumber') {
    tempField = "phoneNumber";
  } else if (field === 'zipCode') {
    tempField = "zipCode";
    tempValue = {
      country: country,
      zipCode: value
    };
  } else if (/address/i.test(field)) {
    tempField = "address";
  }
  return inputError(tempValue, tempField);
};
var updateStateAddressForm = function updateStateAddressForm(addressFields, customersInformation, country) {
  var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var visibleFields = 0;
  Object.keys(addressFields).forEach(function (field) {
    var fieldEl = $("#js-checkoutPaymentForm .js-form-input[data-group=\"address\"][name=\"".concat(field, "\"]"));
    var errorClass = 'is-invalid';
    var isValid = false;
    var isError = addressFields[field].error;
    if ($.inArray(field, ['country', 'state']) !== -1) {
      fieldEl = $("#js-checkout .js-form-input[data-group=\"address\"][data-name=\"".concat(field, "\"]"));
      errorClass = 'has-error';
    }
    if (fieldEl.length === 0) return;
    var value = cleanNonLatinExtended(customersInformation[field]);
    if (value) {
      isError = checkError(field, value);
      isValid = !isError;
    }
    var isDropdown = fieldEl.parent().hasClass('custom-dropdown');
    if (fieldEl.parent().hasClass('required') || isDropdown) {
      fieldEl.val(value);
      updateFieldState(isDropdown ? fieldEl.parent() : fieldEl, isError, errorClass, isValid);
      if (fieldEl.parent().hasClass('required')) fieldEl.parents('.form-group').toggle(addressFields[field].visible);
    } else {
      fieldEl.val(value).toggle(addressFields[field].visible);
      updateFieldState(fieldEl, isError, errorClass, isValid);
    }
    if (addressFields[field].visible) visibleFields += 1;
    if (isError) {
      updateFieldErrorMessage(field, fieldEl, isDropdown, value);
    }
  });
};
var updateStateShippingAddressForm = function updateStateShippingAddressForm(addressFields, customersInformation) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var visibleFields = 0;
  Object.keys(addressFields).forEach(function (field) {
    var fieldEl = $("#js-checkoutPaymentForm .js-form-input[data-group=\"shippingAddress\"][name=\"".concat(field, "\"]"));
    var errorClass = 'is-invalid';
    var isValid = false;
    var isError = addressFields[field].error;
    if ($.inArray(field, ['country', 'state']) !== -1) {
      fieldEl = $("#js-checkout .js-form-input[data-group=\"shippingAddress\"][data-name=\"".concat(field, "\"]"));
      errorClass = 'has-error';
    }
    if (fieldEl.length === 0) return;
    var value = cleanNonLatinExtended(customersInformation[field]);
    if (value) {
      isError = checkError(field, value);
      isValid = !isError;
    }
    var isDropdown = fieldEl.parent().hasClass('custom-dropdown');
    if (fieldEl.parent().hasClass('required') || isDropdown) {
      fieldEl.val(value);
      updateFieldState(isDropdown ? fieldEl.parent() : fieldEl, isError, errorClass, isValid);
      if (fieldEl.parent().hasClass('required')) fieldEl.parents('.form-group').toggle(addressFields[field].visible);
    } else {
      fieldEl.val(value).toggle(addressFields[field].visible);
      updateFieldState(fieldEl, isError, errorClass, isValid);
    }
    if (addressFields[field].visible) visibleFields += 1;
    if (isError) {
      updateFieldErrorMessage(field, fieldEl, isDropdown, value);
    }
  });
};
var updateFieldErrorMessage = function updateFieldErrorMessage(field, fieldEl, isDropdown, value) {
  var errorMessage = window.sitewide.accountEntryErrors.required_field;
  switch (field) {
    case 'password':
      errorMessage = window.sitewide.accountEntryErrors.password;
      break;
    case 'email':
      if (value) errorMessage = window.sitewide.accountEntryErrors.email;
      break;
    case 'passwordRepeat':
      errorMessage = window.sitewide.accountEntryErrors.password_repeat;
      break;
    case 'emailRepeat':
      errorMessage = window.sitewide.accountEntryErrors.email_repeat;
      break;
    default:
      if (value) errorMessage = window.sitewide.accountEntryErrors.incorrect_value;
      break;
  }
  var toReplace = {
    fieldPlaceholder: fieldEl.attr('placeholder'),
    fieldName: fieldEl.data('label') || field
  };
  errorMessage = replaceAllShortcode(errorMessage, toReplace);
  if (isDropdown) {
    fieldEl.parent().after("<div class=\"invalid-feedback p-0\">".concat(errorMessage || '', "</div>"));
  } else {
    fieldEl.after("<div class=\"invalid-feedback p-0\">".concat(errorMessage || '', "</div>"));
  }
};
var getSizeStockData = function getSizeStockData(item, cache) {
  var size = _typeof(item) === 'object' ? item.item : item;
  var cartQuantity = item.quantity;
  var stock = Object.keys(cache.sizes).filter(function (item) {
    return cache.sizes[item].item === size;
  }).map(function (item) {
    return cache.sizes[item].stock;
  }).join("");
  return {
    addedInCart: parseInt(cartQuantity || 0),
    sizeInStock: parseInt(stock || 0)
  };
};
var getPostType = function getPostType(item) {
  return _typeof(item) === "object" && "bundle" in item && item.bundle ? "bundle" : "product";
};
var generateImageMarkup = function generateImageMarkup(images, cache, isBundle) {
  var extraClasses = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var replacePattern = /\.([^.]+)$/;
  var toReplace = '-mini.$1';
  var imageHeight = 100;
  if (isBundle) {
    replacePattern = /sy_standard/;
    toReplace = 'sy_mini';
    imageHeight = 125;
  }
  return "<a href=\"".concat(window.sitewide.prefix).concat(cache.postType || 'product', "/").concat(cache.uri, "/\" class=\"checkout-product-image ").concat(extraClasses, "\">\n\t\t<div class=\"image\"><figure>\n\t\t").concat(images.slice(0, 1).map(function (image) {
    return "<img src=\"".concat(purifier(image).replace(replacePattern, toReplace), "\" \n\t\t\t\talt=\"").concat(purifier(cache.name), "\" \n\t\t\t\twidth=\"100\" height=\"").concat(imageHeight, "\" \n\t\t\t\tonerror=\"this.onerror=null;this.src='").concat(purifier(window.sitewide.imagePlaceholder), "';this.style='background-color:#E8E8E8'\" />");
  }).join(""), "\n\t\t</figure></div>\n\t</a>");
};
var renderSummaryItemImages = function renderSummaryItemImages(item, cache) {
  var isBundle = getPostType(item) === 'bundle' && cache.bundle_image;
  var images = isBundle ? cache.bundle_image : cache.image;
  cache.postType = getPostType(item);
  return generateImageMarkup(images, cache, isBundle);
};
var renderSummaryItemImagesCart = function renderSummaryItemImagesCart(item, cache) {
  var isBundle = getPostType(item) === 'bundle' && cache.bundle_image;
  var images = isBundle ? cache.bundle_image : cache.image;
  cache.postType = getPostType(item);
  return generateImageMarkup(images, cache, isBundle, 'image-wrap');
};
var renderSummaryItemPrice = function renderSummaryItemPrice(item, cache) {
  return "".concat(cache.price.showAsOnSale ? "<del>".concat(purifier(item.priceEachBeforeDiscount || cache.price.priceBeforeDiscount), "</del> ") : '', "<span>").concat(purifier(item.priceEach || cache.price.price), "</span>");
};
var renderReceiptItem = function renderReceiptItem(item, cache) {
  console.log('DEBUG: cache', item, cache);
  if (!cache) return "";
  cache = localizeProductData(cache);
  var _store$getState2 = store.getState(),
    productCache = _store$getState2.productCache;

  // prettier-ignore
  return "\n\t<div class=\"checkout-product-item ".concat(isBundle(item) ? 'is-bundle' : '', "\">\n\t\t").concat(renderSummaryItemImages(item, cache), "\n\t\t<div class=\"checkout-product-info\">\n        ").concat(isBundle(item) ? "<div class=\"checkout-product-details\">\n                    <a href=\"".concat(window.sitewide.prefix).concat(getPostType(item), "/").concat(cache.uri, "/\" class=\"checkout-product-name\">").concat(purifier(cache.name), "</a>\n                </div>") : '', "\n\t\t").concat(isBundle(item) ? item.bundle.map(function (item) {
    var cache = item.product in productCache.items ? localizeProductData(productCache.items[item.product]) : false;
    if (!cache) {
      return "";
    }
    return "<div class=\"checkout-product-details checkout-product-subdetails\">\n\t\t\t\t\t<a href=\"".concat(window.sitewide.prefix, "product/").concat(purifier(cache.uri), "/\" class=\"checkout-product-name\">").concat(cache.name, " <span class=\"sub\">| ").concat(cache.swatch.desc, " | Size ").concat(item.size, "</span></a>\n\t\t\t\t</div>");
  }).join("") : "<div class=\"checkout-product-details checkout-product-subdetails\">\n\t\t\t\t<a href=\"".concat(window.sitewide.prefix, "product/").concat(purifier(cache.uri), "/\" class=\"checkout-product-name\">").concat(cache.name, " <span class=\"sub\"><span class=\"d-none d-lg-inline\">| </span>").concat(cache.swatch.desc, " | Size ").concat(item.size, "</span></a>\n\t\t\t</div>"), "\n\t\t<div class=\"checkout-product-meta\">\n\t\t\t<div class=\"checkout-product-qty checkout-product-details\">\n\t\t\t\t").concat(purifier(window.sitewide.quantity), " ").concat(purifier(item.quantity), "\n\t\t\t</div>\n\t\t\t<div class=\"checkout-product-price\">\n\t\t\t\t").concat(renderSummaryItemPrice(item, cache), "\n\t\t\t</div>\n\t\t</div>\n\t\t</div>\n\t</div>\n  ");
};
var renderPaymentMethodsLogo = function renderPaymentMethodsLogo(escStore) {
  var sitewideLogos = window.sitewide.paymentMethodLogos || {};
  if (!sitewideLogos) return "";
  var logos = sitewideLogos.default;
  if (sitewideLogos.countries[escStore.country]) {
    logos = sitewideLogos.countries[escStore.country];
  }

  // prettier-ignore
  return logos.map(function (logo) {
    return "\n\t\t<img src=\"".concat(purifier(logo.src), "\" alt=\"").concat(purifier(logo.alt), "\">\n    ");
  });
};
var renderCountries = function renderCountries(escStore, countries) {
  var excludeGECountries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (typeof countries === "undefined" || _typeof(countries) !== "object") return "";
  var _store$getState3 = store.getState(),
    geCountries = _store$getState3.geCountries;
  var toExclude = excludeGECountries ? Object.values(geCountries) : [];

  // prettier-ignore
  return Object.keys(countries).filter(function (country) {
    return countries[country].shipTo && toExclude.includes(country) === false;
  }).map(function (country) {
    return "\n\t\t<a class=\"dropdown-item".concat(escStore.country === country ? ' active' : '', "\" data-value=\"").concat(purifier(country), "\" href=\"#\">").concat(purifier(countries[country].name), "</a>\n    ");
  });
  // <option value="${purifier( country )}"${escStore.country === country ? ' selected="selected"' : ''}>${purifier( countries[country].name )}</option>
};
var renderStates = function renderStates(escStore, states) {
  var selectedState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!selectedState) selectedState = escStore.state;
  var country = escStore.country;
  var validUsStates = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

  // prettier-ignore
  var returnArray = Object.keys(states).map(function (state) {
    if (country === 'US' && validUsStates.includes(state) === false) return '';
    return "<a class=\"dropdown-item".concat(selectedState === state ? ' active' : '', "\" data-value=\"").concat(purifier(state), "\" href=\"#\">").concat(purifier(states[state]), "</a>");
  }).filter(function (state) {
    return state;
  });

  // prettier-ignore
  returnArray.unshift("\n\t<a class=\"dropdown-item\" data-value=\"\" href=\"#\">".concat(purifier(window.sitewide.chooseState), "</a>\n  "));
  return returnArray;
};
export { getProductData, extractProductId, localizeProductData, updateStateAddressForm, updateStateShippingAddressForm, getSizeStockData, renderSummaryItemImages, renderSummaryItemImagesCart, renderSummaryItemPrice, renderReceiptItem, renderCountries, renderStates, renderPaymentMethodsLogo };


// WEBPACK FOOTER //
// ./scripts/shop/templates/partials.js